import * as types from './constants';

// Deactivate Code Bulk
export const deactivateCodeBulkRequest = data => (
  { type: types.DEACTIVATE_CODE_BULK_REQUEST, payload: data }
);

export const deactivateCodeBulkDone = data => (
  { type: types.DEACTIVATE_CODE_BULK_DONE, payload: data }
);

export const deactivateCodeBulkFailed = errors => (
  { type: types.DEACTIVATE_CODE_BULK_FAILED, payload: errors }
);